const BR = {
  company: [
    "sociedade limitada (Ltda.)",
    "sociedade simples",
    "associação em sentido estrito (sem finalidade lucrativa)"
  ],
  legalArrangement: [
    "sociedade em nome coletivo",
    "sociedade em comandita simples",
    "associação"
  ],
  soleProprietorship: [
    "microempreendedor Individual (MEI)",
    "Empresa Individual (EI)",
    "sociedade limitada unipessoal (SLU)"
  ]
};
export {
  BR as default
};
